import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.js';

/**
 * @param {object} props
 * @param {(user: object | null) => boolean} props.check
 * @param {React.ReactNode} props.children
 * @param {string} [props.redirectTo]
 */
export function RequirePermission({ check, children, redirectTo = '/home' }) {
    const { user, loading } = useAuth();
    const safeRedirect = typeof redirectTo === 'string' && redirectTo ? redirectTo : '/home';

    if (loading) {
        return <LoadingSpinner />;
    }

    let allowed = false;
    try {
        allowed = typeof check === 'function' ? Boolean(check(user)) : false;
    } catch (err) {
        console.error('RequirePermission check failed:', err);
        allowed = false;
    }

    if (!allowed) {
        return <Navigate to={safeRedirect} replace />;
    }

    return children;
}

RequirePermission.propTypes = {
    check: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    redirectTo: PropTypes.string,
};
